var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./JoinPortfolioReview.less');

module.exports = Section.extend({

    el: '.JoinPortfolioReview',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
    },

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/JoinPortfolioReview/JoinPortfolioReview.js
// module id = 274
// module chunks = 0